import React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'
import { UniqueTimeBlockData } from 'modules/attendance/store/models/UniqueTimeBlockData'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

interface Props {
  transfer: UniqueTimeBlockData
  timeSettingsCategoryById: Record<number, CustomTimeRangeCategory[]>
}

const CategoryItem = ({ transfer, timeSettingsCategoryById }: Props) => {
  const { featureByName } = useTimesheetData()
  const [open, toggle] = useToggle(false)

  const hasExtraHourRules = TimesheetFeatures.EXTRA_HOUR_RULES in featureByName
  const extraHoursWithNegative = hasExtraHourRules && transfer.minutes < 0

  const remainingFromBalanceWithExtraTimeStr = hasExtraHourRules
    ? i18n.t('clock_in.sidepanel.compensation.underwork_deduction')
    : i18n.t('clock_in.sidepanel.compensation.remaining_from_balance')
  const overtimeFromBalanceStr =
    transfer.minutes > 0
      ? i18n.t('clock_in.sidepanel.compensation.overtime_from_balance')
      : remainingFromBalanceWithExtraTimeStr

  const name = transfer.name
    ? transfer.name
    : transfer.timeSettingsCustomTimeRangeCategoryId
      ? timeSettingsCategoryById[transfer.timeSettingsCustomTimeRangeCategoryId]?.[0]?.name ||
        overtimeFromBalanceStr
      : overtimeFromBalanceStr

  return (
    <Box gap="s2">
      <Box flexDirection="row" justifyContent="spaceBetween" width="full" gap="s2">
        <Box flexDirection="row" alignItems="flexStart">
          <Box width="s200">
            <Text.Normal size="200" color="grey1000" weight="medium" ellipsis>
              {transfer.isDiscardedSource
                ? i18n.t('clock_in.sidepanel.compensation.discarded_by_limit')
                : name}
            </Text.Normal>
          </Box>
          {extraHoursWithNegative && (
            <Tooltip.Alt
              attachment="bottom left"
              open={open}
              toggle={toggle}
              label={i18n.t('clock_in.sidepanel.compensation.underwork_deduction_tooltip')}
            >
              <Icon.Medium icon="info-circle-line" color="grey800" />
            </Tooltip.Alt>
          )}
        </Box>
        <MinutesToText
          color="grey1000"
          value={transfer.isDiscardedSource ? -transfer.minutes : transfer.minutes}
          size="300"
          weight="medium"
          whiteSpace="nowrap"
        />
      </Box>
      {!hasExtraHourRules && (
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="200" weight="normal" color="grey1000">
            {i18n.t('clock_in.sidepanel.compensation.hour_value')}
          </Text>
          <Box flexDirection="row">
            <MinutesToText
              color="grey1000"
              value={transfer.rawMinutes}
              size="200"
              weight="normal"
            />
            <Text size="200" weight="normal" color="grey1000">
              =
            </Text>
            <MinutesToText
              color="grey1000"
              value={transfer.equivalentMinutes}
              size="200"
              weight="normal"
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CategoryItem
